"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var settings = [// {
//   id: 'mrt-font-notosans-dns',
//   href: 'https://fonts.gstatic.com',
// },
{
  id: 'mrt-icons-dns',
  href: 'https://dffoxz5he03rp.cloudfront.net',
  as: 'fetch',
  rel: 'preload',
  crossorigin: 'anonymous'
}];

exports.default = function () {
  settings.forEach(function (setting) {
    if (!document.getElementById(setting.id)) {
      var linkTag = document.createElement('link');
      linkTag.id = setting.id;
      linkTag.href = setting.href;
      linkTag.rel = setting.rel;
      linkTag.as = setting.as;
      linkTag.crossOrigin = setting.crossorigin;
      document.head.appendChild(linkTag);
    }
  });
};